import {Card, Col, Row} from "react-bootstrap";
import Container from "react-bootstrap/Container";
import API from "../../api/api";
import {useEffect, useState} from "react";
import {Link} from "react-router-dom";

function Products() {
    const [products, setProducts] = useState(false);


    useEffect(() => {
        API.get("products/all").then(response => {
            setProducts(response.data);
        })

    }, []);


    return (
        <div className="bg-gradient-dark text-white">
            <Container data-bs-theme="dark">
                <Row className={"m-5 pt-5 d-flex justify-content-center"}>
                    {!products &&
                        <div className="spinner-border" role="status">
                        </div>
                    }
                    {products && products.map((productInfo, i) => (
                        <Col key={i}>
                            <Link to={`/products/` + productInfo.id}
                                  className="text-decoration-none d-flex justify-content-center">
                                <Card style={{width: '18rem'}} className=" h-100">
                                    <Card.Body>
                                        <Card.Title>{productInfo.name}</Card.Title>
                                        <Card.Subtitle>${productInfo.price.unit_amount/100}</Card.Subtitle>
                                        <Card.Text>
                                            {productInfo.description}
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                    ))}
                </Row>
            </Container>

        </div>
    );
}

export default Products;